/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./menu-partial-ratio";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_MenuPartialRatioPage = [];
var RenderType_MenuPartialRatioPage = i0.ɵcrt({ encapsulation: 2, styles: styles_MenuPartialRatioPage, data: {} });
export { RenderType_MenuPartialRatioPage as RenderType_MenuPartialRatioPage };
export function View_MenuPartialRatioPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [], [[8, "className", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i0.ɵinlineInterpolate(1, "circle ", _co.color, ""); _ck(_v, 0, 0, currVal_0); }); }
export function View_MenuPartialRatioPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-menu-partial-ratio", [], null, null, null, View_MenuPartialRatioPage_0, RenderType_MenuPartialRatioPage)), i0.ɵdid(1, 49152, null, 0, i1.MenuPartialRatioPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var MenuPartialRatioPageNgFactory = i0.ɵccf("page-menu-partial-ratio", i1.MenuPartialRatioPage, View_MenuPartialRatioPage_Host_0, { color: "color" }, {}, []);
export { MenuPartialRatioPageNgFactory as MenuPartialRatioPageNgFactory };
//# sourceMappingURL=menu-partial-ratio.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/menu/menu-list/menu-partial-ratio/menu-partial-ratio.ngfactory.js
// module id = null
// module chunks = 